

const beliefs = [
  {
    image: '/services_img/collab.svg',
    title: 'C – Collaborative Approach',
    description: 'Working closely with clients to align tech with real business goals.',
  },
  {
    image: '/services_img/accountability.svg',
    title: 'A – Accountable Ownership',
    description: 'Taking full responsibility from strategy to successful delivery.',
  },
  {
    image: '/services_img/Result.svg',
    title: 'R – Result-Driven Delivery',
    description: 'Focusing on measurable outcomes that drive real business impact.',
  },
  {
    image: '/services_img/Endure.svg',
    title: 'E – Enduring Trust',
    description: 'Building long-term partnerships through integrity and transparency.',
  },
];

export default beliefs;
